﻿<template>
    <b-card class="border-0 product-action">
        <b-list-group>
            <b-list-group-item v-if="!isMobileList && (showDatasheet && enableDatasheetGeneration || datasheet)" button @click="getProductDataSheet">
                <div class="icon-frame">
                    <img src="/src/assets/main/categories-temporary/datasheet-icon.svg" :alt="$t('datasheet')" />
                </div>
                <p class="main-button-title my-auto">{{ $t('datasheet') }}</p>
            </b-list-group-item>

            <b-list-group-item v-if="installation && !isMobileList" :href="installation" target="_blank">
                <div class="icon-frame">
                    <img src="/src/assets/main/categories-temporary/installation-icon.svg" :alt="$t('installation')" />
                </div>
                <p class="main-button-title my-auto">{{ $t('installation') }}</p>
            </b-list-group-item>

            <template v-if="!quoteId">
                <b-list-group-item button @click="requestQuote()" :class="[{'spanish': $i18n.locale !== 'en' }, 'request-quote btn-trimm-wide rounded-pill text-light']">
                    <div class="icon-frame">
                        <img src="/src/assets/main/categories-temporary/request-icon.svg" :alt="$t('requestQuote')" />
                    </div>
                    <p class="main-button-title my-auto">{{ $t('requestQuote') }}</p>
                </b-list-group-item>

                <b-list-group-item v-if="!isMobileList && !isFuses && !isCompare" button @click="addToCompareList">
                    <div class="icon-frame">
                        <img src="/src/assets/main/categories-temporary/compare-icon.svg" :alt="$t('compare')" />
                    </div>
                    <p class="main-button-title my-auto">{{ $t('compare') }}</p>
                </b-list-group-item>
            </template>

            <template v-else-if="quoteId > 0 && !isMobileList">
                <b-list-group-item button @click="removeQuote()">
                    <div class="icon-frame">
                        <img src="/src/assets/main/categories-temporary/trash-icon.svg" :alt="$t('removeItem')" />
                    </div>
                    <p class="main-button-title my-auto">{{ $t('removeItem') }}</p>
                </b-list-group-item>

                <b-list-group-item button @click="updateQuote()">
                    <div class="icon-frame">
                        <img src="/src/assets/main/categories-temporary/update-icon.svg" :alt="$t('updateQuantity')" />
                    </div>
                    <p class="main-button-title my-auto">{{ $t('updateQuantity') }}</p>
                </b-list-group-item>
            </template>

        </b-list-group>
    </b-card>
</template>

<script>
    import QueryUtils from "@/utils/query-utils";
    import { ShoppingCartType } from "@/enums";
    import { shoppingCartService, wishlistService, productService } from "@/services";
    import QuoteToast from "@/components/common/toasts/quote-toast.vue";
    import CompareToast from '@/components/common/toasts/compare-toast.vue';
    import { useToast } from "vue-toastification";
    import ProductUtils from "@/utils/product-utils";
    import downloadFileMixin from "@/mixins/download-file-mixin";
    import { LOCALSTORAGE_METRIC_KEY } from '@/constants/products-info';

    export default {
        name: 'product-action',

        mixins: [downloadFileMixin],

        setup() {
            const toast = useToast();

            return { toast };
        },

        props: {
            productId: {
                type: Number,
                required: true
            },

            quoteId: {
                type: Number,
                default: null
            },

            quantity: {
                type: Number,
                default: null
            },

            datasheet: {
                type: String,
                default: null
            },

            installation: {
                type: String,
                default: null
            },

            isCompare: {
                type: Boolean,
                default: false
            },

            isMobileList: {
                type: Boolean,
                default: false
            },

            enableDatasheetGeneration: {
                type: Boolean,
                default: false
            },

            showDatasheet: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            isFuses() {
                return ProductUtils.isFuseProduct(this.$route);
            }
        },

        methods: {
            async requestQuote() {
                let data = {
                    quantity: this.quantity,
                    shoppingCartType: ShoppingCartType.Wishlist
                };

                let response = await shoppingCartService.addProductToCartFromCatalog(this.productId, QueryUtils.transformObjectToQueryParams(data));

                if (response.errors !== null) {
                    this.showErrorMessages(response.errors);
                } else {
                    this.toast.success(QuoteToast);

                    this.emitter.emit('updateHeaderLinks', await wishlistService.getHeaderLinks());
                }
            },

            async removeQuote() {
                let data = {
                    removefromcart: this.quoteId
                };

                await this.sendUpdateRequest(data);
            },

            async updateQuote() {
                let data = {};

                data[`itemquantity${this.quoteId}`] = this.quantity;

                await this.sendUpdateRequest(data);
            },

            async sendUpdateRequest(data) {
                let response = await wishlistService.updateQuote(data);

                this.$emit('updateQuoteCart', this.quoteId);

                if (response.warnings && response.warnings.length)
                    this.showErrorMessages(response.warnings);
                else
                    this.$root.successToast(this.$t('quoteUpdated'));

                this.emitter.emit('updateHeaderLinks', await wishlistService.getHeaderLinks());
            },

            showErrorMessages(errors) {
                for (let i = 0; i < errors.length; i++)
                    this.$root.errorToast(errors[i]);
            },

            async addToCompareList() {
                this.$root.showOverlay();

                await productService.addProductToCompareList(this.productId);

                this.$root.hideOverlay();
                this.toast.success(CompareToast);
            },

            async getProductDataSheet() {
                if (this.enableDatasheetGeneration) {
                    let response = await productService.getProductDataSheet(this.productId, localStorage.getItem(LOCALSTORAGE_METRIC_KEY) === 'true');

                    if (response.data?.size !== 0) {
                        this.fileAutoDownload(response.data, this.getFileNameFromAxiosResponseHeaders(response.headers));
                        return;
                    }
                }

                window.open(this.datasheet, '_blank');
            }
        }
    }
</script>